// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__16lEL","imageUploader":"EGiftCard_imageUploader__FIMTi"};